import { jsx as _jsx } from "react/jsx-runtime";
import enviro from 'enviro';
import UILink from 'UIComponents/link/UILink';
import { useConnectDotComUser } from '../connectDotComQueries';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import useIsPublicUrl from '../../../hooks/useIsPublicUrl';
const connectDotComDomain = enviro.isQa() ? 'connectqa.co' : 'connect.com';

const JoinConnectDotComLink = () => {
  return /*#__PURE__*/_jsx(UILink, {
    href: `https://${connectDotComDomain}/introduction`,
    target: "_blank",
    use: "on-dark",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.connectDotCom.join"
    })
  });
};

export const ConnectDotComLink = ({
  userId
}) => {
  const {
    connectDotComUser,
    connectDotComUserLoading
  } = useConnectDotComUser(userId);
  const isPublic = useIsPublicUrl();
  if (connectDotComUserLoading) return null;

  if (!connectDotComUser) {
    if (!isPublic) {
      return /*#__PURE__*/_jsx(JoinConnectDotComLink, {});
    }

    return null;
  }

  return /*#__PURE__*/_jsx(UILink, {
    href: `https://${connectDotComDomain}/member/${connectDotComUser.userName}`,
    target: "_blank",
    use: "on-dark",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${isPublic ? 'academyPublic' : 'learningCenter'}.connectDotCom.view`
    })
  });
};